<template>
  <b-modal
    id="modal-prevent-closing"
    ref="modal"
    title="Private Key Passphrase"
    :ok-only="true"
    :visible="isVisible"
    :hide-footer="true"
    :hide-header-close="true"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true ? true : false"
    size="md"
  >
    <form ref="form" @submit.stop.prevent="handleSubmit">
      <b-row class="mb-3">
        <b-col lg="12">
          <b-form-input
            id="private-key"
            v-model="passphrase"
            :state="Boolean(passphrase)"
            placeholder="Passphrase"
            type="password"
            required
          ></b-form-input>
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col lg="4">
          <b-button
            type="button"
            variant="primary"
            block
            @click="submit_passphrase"
            >Confirm</b-button
          >
        </b-col>
        <b-col lg="4">
          <b-button type="button" variant="secondary" block @click="redirect"
            >Cancel</b-button
          >
        </b-col>
      </b-row>
    </form>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex'
// import CryptoJS from 'crypto-js'

export default {
  props: {
    isVisible: Boolean
  },
  data() {
    return {
      passphrase: ''
    }
  },
  methods: {
    handleSubmit() {
      this.$nextTick(() => {
        this.$bvModal.hide('modal-prevent-closing')
      })
    },
    submit_passphrase: function() {
      this.$emit('clicked', this.passphrase)
    },
    redirect: function() {
      this.$emit('redirect', '/')
    }
  },
  computed: {
    ...mapState(['modal'])
  }
}
</script>

<style>
* {
}
</style>
